import { __awaiter } from "tslib";
import { decrementOpenRequests, incrementOpenRequests, } from "../reducers/actions";
import { getSessionId } from "../reducers/selectors";
export function saveConfiguration() {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        try {
            dispatch(incrementOpenRequests());
            const rootState = getState();
            const sessionid = getSessionId(rootState);
            // call api
            const response = yield cfgApi.saveConfiguration({ id: sessionid });
            return response;
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=saveConfiguration.js.map